import {createBrowserHistory} from 'history';

export const appHistory = createBrowserHistory();
